/**
 * Shared background for the public welcome/signup screens (landing + registration
 * success): a UNIFORM whisper-tint of the primary (chrome) token laid over white —
 * same color from edge to edge (a flat two-stop layer over #fff), so it can never
 * read as a detached band the way a fading gradient did under the wave header.
 * Built from the primary -rgb channel (literal fallback inline) so it re-skins per
 * study. Applied via setResonanceLayout({ backgroundColor }) — ResonanceLayout
 * paints it with the CSS `background` shorthand, so a gradient string is valid.
 */
export const WELCOME_BACKGROUND =
  "linear-gradient(0deg," +
  " rgba(var(--app-color-primary-rgb, 148, 241, 239), 0.06)," +
  " rgba(var(--app-color-primary-rgb, 148, 241, 239), 0.06)), #ffffff";
